import type { ScratchcardOrderQuery } from '#api/shared/@types/generated/backend/graphql-schema-types'

export default defineNuxtRouteMiddleware(async (to) => {
  const client = useNuxtApp().$apollo.defaultClient
  const { navigateToLocalized } = useRouterUtils()
  const { addToast } = useToaster()
  const { t } = useNuxtApp().$i18n

  const FALLBACK_ROUTE = `/my-orders/scratchcards`

  try {
    await client.query<ScratchcardOrderQuery>({
      fetchPolicy: 'network-only',
      query: ScratchcardOrderDocument,
      variables: { orderId: to.params.id },
    })
  } catch (error) {
    if (!isApolloError(error)) {
      return navigateToLocalized({ path: FALLBACK_ROUTE, replace: true })
    }

    const errorMessage = error.graphQLErrors[0].message
    if (errorMessage === 'validation.scratchcardorder.notfound') {
      addToast({
        headline: t('error.order.notfound.headline'),
        message: t('error.order.notfound.message'),
        tracking: { topicKey: 'scratchcard_not_found' },
        type: 'danger',
      })
    }

    return navigateToLocalized({ path: FALLBACK_ROUTE, replace: true })
  }
})
